// extracted by mini-css-extract-plugin
export default {"NewViewGraphicContainer":"NewViewGraphic-module__NewViewGraphicContainer--hX_4x"};